<script>
import myMixin from '@/mixins/crud.js'
export default {
  name: 'ContactComponent',
  mixins: [ myMixin ],
  data: function () {
    return {
      submitted: false,
      formData: {
        firstname: '',
        lastname: '',
        email: '',
        comment: ''
      },
      dialog: false
    }
  },
  watch: {
    dialog: function (newVal, oldVal) { // watch it
      this.clearForm()
    }
  },
  methods: {
    setData: function (response, err) {
      if (err) {
        console.log(err)
        this.error = err.toString()
      } else {
        console.log(response.data)
        this.$swal(
          'Success!',
          'Thanks you ' + response.data.firstname + ', your message has been sent',
          'success'
        )
        this.dialog = false
      }
    },
    clearForm () {
      this.formData = {
        firstname: '',
        lastname: '',
        email: '',
        comment: ''
      }
      this.$validator.reset()
      this.$nextTick(function () {
        this.$validator.reset()
        this.flags = []
      })
    },
    closeAndClear () {
      this.dialog = false
      this.formData = {
        firstname: '',
        lastname: '',
        email: '',
        comment: ''
      }
      this.$validator.reset()
      this.$nextTick(function () {
        this.$validator.reset()
      })
    }
  }
}
</script>
<template>
  <section id="contact" class="white">

    <!-- START PARALLAX HEADER -->
    <v-parallax src="/static/img/parallax-contact.jpg" height="300">
    </v-parallax>
    <!-- END PARALLAX HEADER -->
      <v-container grid-list-lg class="maxed">
        <v-layout row wrap>

          <v-flex xs12 md4 offset-md3>
              <ul class="contact">
                <li><v-icon>phone</v-icon>(709) 282-5050</li>
                <li><v-icon>phone_iphone</v-icon>(709) 282-8613</li>
                <li><v-icon>mail</v-icon><a href="mailto:lcrplus@crrstv.net?subject=LCRPlus Question">lcrplus@crrstv.net</a></li>
              </ul>
          </v-flex>

          <v-flex xs12 md5>
              <ul class="contact">
                <li><v-icon>place</v-icon>10 First Steet, Wabush Industrial Park, NL</li>
                <li class="ml-5">A0R 1B0</li>
                <li class="ml-5">Canada</li>
              </ul>
          </v-flex>

        </v-layout>
      </v-container>
  </section>
</template>



// WEBPACK FOOTER //
// src/components/Contact.vue